import { ReactNode } from 'react';

export const CriteriaLabel = ({ children }: { children: ReactNode }) => (
  <div className="mx-0 mb-2 mt-15px flex justify-between font-heebo text-sm font-normal">
    {children}
  </div>
);

export const CriteriaBox = ({ children }: { children: ReactNode }) => (
  <div className="w-391px">{children}</div>
);

export const Subheader = ({ children }: { children: ReactNode }) => (
  <div className="mx-0 mb-3 mt-0 font-heebo text-sm font-normal">{children}</div>
);
